import React, { useState, useEffect } from "react";
// import PropTypes from "prop-types";
import { Link, useSearchParams } from "react-router-dom";
import styled from "styled-components";

// source
import ArrowBack from "../assets/icons/arrow_back.svg";
import { useTranslation } from "react-i18next";

const StyledSingleButtonLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 32px);
  height: 48px;
  border-radius: 4px;
  background-color: #1d4993;
  color: white;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.3s ease;
  font-size: 14px;

  &:hover {
    background-color: #2563eb;
  }
`;

const StyledDoubleButtonLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(50% - 16px);
  height: 48px;
  background-color: #014b98;
  color: white;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.3s ease;
  font-size: 14px;

  &:hover {
    background-color: #2563eb;
  }
`;
// 1D4993
// 3b82f6
const Detail = () => {
  const { t, i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const startPoint = JSON.parse(sessionStorage.getItem("startPoint"));
  const endPoint = JSON.parse(sessionStorage.getItem("endPoint"));
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const renderNaviTypeBtn = () => {
    if (!startPoint) {
      // 길찾기하는 방법 (이미지)
      return (
        <div
          style={{
            position: "fixed",
            display: "flex",
            width: "100vw",

            zIndex: 1,
            bottom: 0,
            left: 0,
            inset: "auato 0 0 auto",

            color: "#423630",
            alignItems: "center",
            justifyContent: "center",

            height: "80px",
            backgroundColor: "white",
          }}
        >
          <StyledSingleButtonLink to="/guide-qr">
            {t("detail.buttonNavigateOnlyImage")}
          </StyledSingleButtonLink>
        </div>
      );
    } else if (
      startPoint.name["ko-KR"] === "금봉미술관" ||
      startPoint.region === "서구" ||
      startPoint.region === "광산구" ||
      endPoint.region === "서구" ||
      endPoint.region === "광산구" ||
      endPoint.name["ko-KR"] === "금봉미술관"
    ) {
      // 출발지가 금봉미술관, 서구 전시장, 광산구 -> 대중교통
      return (
        <div
          style={{
            position: "fixed",
            display: "flex",
            width: "100vw",

            zIndex: 1,
            bottom: 0,
            left: 0,
            inset: "auato 0 0 auto",

            color: "#423630",
            alignItems: "center",
            justifyContent: "center",

            height: "80px",
            backgroundColor: "white",
          }}
        >
          <StyledSingleButtonLink to="/path?transport=public">
            {t("detail.buttonNavigatePublic")}
          </StyledSingleButtonLink>
        </div>
      );
    } else {
      if (startPoint.region === endPoint.region) {
        // 도보
        return (
          <div
            style={{
              position: "fixed",
              display: "flex",
              width: "100vw",

              zIndex: 1,
              bottom: 0,
              left: 0,
              inset: "auato 0 0 auto",

              color: "#423630",
              alignItems: "center",
              justifyContent: "center",

              height: "80px",
              backgroundColor: "white",
            }}
          >
            <StyledSingleButtonLink to="/path?transport=walk">
              {t("detail.buttonNavigateWalkWay")}
            </StyledSingleButtonLink>
          </div>
        );
      } else if (startPoint.region !== endPoint.region) {
        // 셔틀버스, 대중교통
        return (
          <div
            style={{
              position: "fixed",
              display: "flex",
              width: "100vw",

              zIndex: 1,
              bottom: 0,
              left: 0,
              inset: "auato 0 0 auto",

              color: "#423630",
              alignItems: "center",
              justifyContent: "center",

              height: "80px",
              backgroundColor: "white",
            }}
          >
            <StyledDoubleButtonLink
              style={{
                borderTopLeftRadius: "4px",
                borderBottomLeftRadius: "4px",
              }}
              to="/path?transport=shuttle"
            >
              {t("detail.buttonNavigateShuttle")}
            </StyledDoubleButtonLink>
            <div
              style={{
                width: "1px",
                color: "#fff",
                height: "100%",
                display: "flex",
              }}
            >
              <div
                style={{
                  width: "1px",
                  color: "#fff",
                  height: "33.3%",
                }}
              ></div>
              <div
                style={{
                  width: "1px",
                  color: "#fff",
                  height: "33.3%",
                }}
              ></div>
              <div
                style={{
                  width: "1px",
                  color: "#fff",
                  height: "33.3%",
                }}
              ></div>
            </div>
            <StyledDoubleButtonLink
              style={{
                borderTopRightRadius: "4px",
                borderBottomRightRadius: "4px",
              }}
              to="/path?transport=public"
            >
              {t("detail.buttonNavigatePublic")}
            </StyledDoubleButtonLink>
          </div>
        );
      }
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div
        style={{
          position: "fixed",
          display: "flex",

          zIndex: 1,
          top: 16,
          left: 16,
          inset: "auato 0 0 auto",
        }}
      >
        <Link to="../">
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: 0,
            }}
          >
            <img src={ArrowBack} alt="" />
          </button>
        </Link>
      </div>

      <div
        style={{
          // zIndex: 3,
          position: " absolute",
          top: 0,
          left: 0,
          // width: "100%",
          height: "100%",
          backgroundColor: "white",
          padding: "16px",
          color: "#282D4B",

          // overflow: "hidden",
        }}
      >
        <div
          style={{
            padding: "44px 0 0 0",
          }}
        >
          <div
            style={{
              marginBottom: "20px",
              width: "calc(100vw - 32px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <img
              style={{
                objectFit: "contain",
                borderRadius: "20px",
                width: "100%",
                maxHeight: "100%",
              }}
              src={endPoint.img}
              alt=""
            ></img>
          </div>
        </div>
        <div
          style={{
            fontSize: "22px",
            padding: "0 6px 0px",
          }}
        >
          <span style={{ color: "#477AE9", fontWeight: 600 }}>
            {endPoint.name[i18n.language]}
          </span>
          <br />
          <div style={{ display: "flex", marginTop: "8px" }}>
            <span
              style={{
                color: "#444444",
                fontSize: "15px",
                marginRight: "12px",
                fontWeight: 600,
              }}
            >
              {t("detail.openTime")}
            </span>
            <span
              style={{
                color: "#444444",
                fontSize: "15px",
                whiteSpace: "pre-wrap",
              }}
            >
              {endPoint.operating_time[i18n.language]}
            </span>
          </div>
          <br />
        </div>
        <div
          style={{
            backgroundColor: "#EEEEEE",
            width: "calc(100vw - 32px)",
            height: "2px",
            marginBottom: "8",
          }}
        ></div>
        <div
          style={{
            textAlign: "left",
            lineHeight: "24px",
            padding: "13px 0px",
            width: "calc(100vw - 36px)",
            color: "#666666",
            borderRadius: "8px",
            paddingBottom: "100px",
            fontSize: "15px",
          }}
        >
          {endPoint.introduction[i18n.language]}
        </div>
      </div>
      {renderNaviTypeBtn()}
    </div>
  );
};

export default Detail;
